import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { xingConnect } from '@xingternal/xing-frame-provider';
import Userbadge, {
  TYPE_BASIC,
  TYPE_EXECUTIVE,
  TYPE_PREMIUM,
} from '@xingternal/malt-userbadge';
import { pathOr } from '@xingternal/malt-util/objects';
import UserImage from '@xingternal/malt-user-image';

import styles from './Me.css';
import { TrackedLink, withTracking, eitherOr } from '../xing-tracking';
import trackings from '../trackings';

const genderMap = {
  FEMALE: 'f',
  MALE: 'm',
  NONE: null,
};

const Me = ({ features, user }) => {
  const { displayName, profileImage, gender } = user;
  const { isExecutive = false, isPremium = false } = features;
  const image = pathOr(null, [0, 'url'], profileImage);
  const userImageProps = {
    userName: displayName,
    src: image,
    gender: genderMap[gender],
    className: classNames(styles.figure, {
      [styles.emptyFigure]: !image,
    }),
  };

  const trackingConditions = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    sc_o_PropActionOrigin: eitherOr(displayName),
  };

  const displayBadge = isExecutive
    ? TYPE_EXECUTIVE
    : isPremium
    ? TYPE_PREMIUM
    : TYPE_BASIC;

  return (
    <TrackedLink
      href="/profile"
      trackingKey="profile"
      conditions={trackingConditions}
      className={styles.profile}
    >
      <figure className={styles.innerProfile}>
        <UserImage
          size="300"
          sizeConfined="200"
          sizeWide="300"
          {...userImageProps}
        />

        <figcaption
          className={classNames(styles.caption, {
            [styles.emptyCaption]: !displayName,
          })}
        >
          <p
            className={classNames(styles.userName, {
              [styles.emptyUserName]: !displayName,
            })}
          >
            {displayName}
          </p>

          {displayBadge ? (
            <Userbadge
              type={displayBadge}
              className={classNames(styles.membership, {
                [styles.executiveBadge]: displayBadge === TYPE_EXECUTIVE,
              })}
            />
          ) : (
            displayBadge && <span className={styles.badgePlaceholder} />
          )}
        </figcaption>
      </figure>
    </TrackedLink>
  );
};

Me.propTypes = {
  features: PropTypes.object,
  user: PropTypes.object,
  flavour: PropTypes.string,
};

export { Me };
export default withTracking(trackings)(xingConnect()(Me));
